module.exports = __webpack_public_path__ + "static/media/F-3.8513b8ff.webp";